import React from 'react';
// import PropTypes from 'prop-types';
// import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// import clsx from 'clsx';

import AppBar from '@material-ui/core/AppBar';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import Typography from '@material-ui/core/Typography';
// import Zoom from '@material-ui/core/Zoom';
// import Fab from '@material-ui/core/Fab';
import { green } from '@material-ui/core/colors';
// import Hidden from '@material-ui/core/Hidden';
import Toolbar from '@material-ui/core/Toolbar';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { Container, Grid, Snackbar, CircularProgress, Typography } from '@material-ui/core';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';




//icons
// import AddIcon from '@material-ui/icons/Add';
// import EditIcon from '@material-ui/icons/Edit';
// import UpIcon from '@material-ui/icons/KeyboardArrowUp';

//custom
// import BottomNavigation from './BottomNavigation';
import Moeda from './Moeda';
import DialogCoin from './DialogCoin'

// API
import api from '../api/coins/api'
// api exemplo
// import apiTest from '../api/coins/coins-20.json'
// const _listCoins = apiTest.data.coins;


//img
// import logo from '../images/logo-icone.svg'
import logoBranco from '../images/logo-branca.svg'

//util
import { installOfflineWatcher } from '../utils/offline'
import ButtonAdd from './ButtonAdd';






//  DnD
const SortableItem = sortableElement(({ value, openDialogSelected, quebraGrid, idCard, isBase }) =>
    <Grid item xs={quebraGrid ? 3 : 6}>
        <Moeda
            coin={value}
            volume={typeof value.conversaoHoje !== 'undefined' ? value.conversaoHoje.volume : 0}
            onClick={() => openDialogSelected(value, idCard)}
            fiat={!value.cripto}
            isBase={isBase}
        />
    </Grid>
);

const SortableContainer = sortableContainer(({ children }) => {
    // return <ul>{children}</ul>;
    return <Grid container spacing={2} >
        {children}
    </Grid>
});

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.default,
        // width: 500,
        // backgroundColor: '#E7EFF8',
        // position: 'relative',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
        userSelect: 'none'
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(4),
        right: theme.spacing(2),
    },
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[600],
        },
    },
    dialog: {
        overflowY: 'visible'
    },
    logoIcon: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    container: {
        paddingTop: theme.spacing(14),
        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(11),
            paddingBottom: theme.spacing(12)
        }
    },
    progress: {
        margin: theme.spacing(2),
    },
    snackbar: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.dark
    }
}));

export default function Main(props) {
    const classes = useStyles();
    const theme = useTheme();
    const quebraGrid = useMediaQuery(theme.breakpoints.up('md'))
    const fullScreenDialog = useMediaQuery(theme.breakpoints.down('sm'))

    const [offLine, setOffLine] = React.useState(true);
    const [coinSelected, setCoinSelected] = React.useState(null);
    const [idCardSelected, setIdCardSelected] = React.useState(null);
    const [idBase, setIdBase] = React.useState(0);
    const [openDialogConvert, setOpenDialogConvert] = React.useState(false);
    const [listCoinsConvert, setListCoinsConvert] = React.useState([]);
    const [completed, setCompleted] = React.useState(0);


    React.useEffect(() => {

        installOfflineWatcher((off) => {
            if (off) {
                console.log("Parece que você está offLine");
            }
            setOffLine(off)
        })

        const storageListCoinsConvert = getStorageListCoinsConvert()
        const storageGlobal = getStorageGlobal()

        if (storageGlobal) {
            setIdBase(storageGlobal.base)
        }


        if (storageListCoinsConvert && storageListCoinsConvert.length > 1) {
            setListCoinsConvert(storageListCoinsConvert)
        } else {
            api.coins('EUR')
                .then(
                    (result) => {
                        console.log(result);
                        setListCoinsConvert([
                            {
                                ...result.allCoins[33], conversaoHoje: { // bitcoin
                                    volume: 1
                                }
                            },
                            {
                                ...result.allCoins[1], conversaoHoje: { // real
                                    volume: 0
                                }
                            },
                            {
                                ...result.allCoins[3], conversaoHoje: { // dolar ame
                                    volume: 0
                                }
                            },

                        ])
                    })
                .catch(err => {
                    console.log('[erro]', err)
                })
        }
        // addListCoinsConvert(result.allCoins[1], 0)

    }, [])
    React.useEffect(() => {
        const atualizarPrecos = () => {
            // console.log('chamou');
            api.coins('USD')
                .then((result) => {
                    setListCoinsConvert(prevlist =>
                        convertCoins(idBase, prevlist.map((item, index) => {
                            const id = result.allCoins.map(function (e) { return e.name; }).indexOf(item.name);
                            return (
                                {
                                    ...item,
                                    price: result.allCoins[id].price
                                }
                            )
                        }))
                    )
                })
                .catch(error => {
                    console.log("Algum erro de conexão: ", error)
                })

        }

        const progress = () => {
            setCompleted(prevCompleted => {
                if (prevCompleted === 0) {
                    atualizarPrecos()
                }
                return (prevCompleted >= 100 ? 0 : prevCompleted + 0.66)
                // return (prevCompleted >= 100 ? 0 : prevCompleted + 2.5)
            });
        }
        let timer
        if (!offLine) {
            timer = setInterval(progress, 4000);
            // timer = setInterval(progress, 1000);
        }

        updateStorageGlobal({
            base: idBase
        })

        return () => {
            clearInterval(timer);
        };
    }, [offLine, idBase]);
    React.useEffect(() => {
        updateStorageListCoinsConvert(listCoinsConvert)
    }, [listCoinsConvert])

    const updateStorageGlobal = (infosGlobal) => {
        localStorage.setItem('@conversao-hoje/global', JSON.stringify(infosGlobal));
    }
    const getStorageGlobal = () => {
        return JSON.parse(localStorage.getItem('@conversao-hoje/global'));
    }
    const updateStorageListCoinsConvert = (listCoins) => {
        localStorage.setItem('@conversao-hoje/list-coins-convert', JSON.stringify(listCoins));
    }
    const getStorageListCoinsConvert = () => {
        return JSON.parse(localStorage.getItem('@conversao-hoje/list-coins-convert'));
    }


    const openDialogNew = () => {
        // console.log('New entrou');

        setOpenDialogConvert(true)
        setCoinSelected(null)
        setIdCardSelected(null)
    }
    const openDialogSelected = (coin, idCard) => {
        // console.log('[openDialogSelected] idCard: ', idCard);

        setOpenDialogConvert(true)
        setCoinSelected(coin)
        setIdCardSelected(idCard)
    }


    const convertCoins = (idbase, coins) => {
        const fator = coins[idbase].conversaoHoje.volume * coins[idbase].price
        // console.log('Base: ', coins[idbase]);

        return coins.map((item, index) => {
            return {
                ...item, conversaoHoje: {
                    volume: index !== idbase ?
                        fator * (1 / item.price) :
                        item.conversaoHoje.volume
                }
            }
        })
    }


    const addListCoinsConvert = (coin, volume, idCard, isBase) => {
        // console.log('idCard: ', idCard);

        let base = listCoinsConvert.map(function (e) { return e.name; }).indexOf(coin.name);

        let cloneList = JSON.parse(JSON.stringify(listCoinsConvert))


        const newCoin = {
            ...coin, conversaoHoje: {
                volume: parseFloat(volume) || 0
            }
        }

        if (base !== -1 && base !== idCard) { // se ja existir exclui
            cloneList = cloneList.filter((item, index) => index !== base)
            if (base === idBase) {
                isBase = true
            }
        }

        if (idCard !== null) { // Editar

            base = idCard
            cloneList[idCard] = newCoin
            // console.log('[addMoeda] entrou, idcard: ', idCard);

        } else { // Add
            base = cloneList.push(newCoin) - 1
        }

        // console.log(cloneList);
        if (volume && volume !== 0) {
            setListCoinsConvert(convertCoins(base, cloneList))
        } else {
            setListCoinsConvert(convertCoins(idBase, cloneList))
        }

        if (isBase) {
            setIdBase(base)
        }

    }

    const removeListCoinsConvert = (coin) => {
        const pos = listCoinsConvert.map(function (e) { return e.name; }).indexOf(coin.name);
        const newList = listCoinsConvert.filter((item, index) => index !== pos)
        setListCoinsConvert(newList)
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setListCoinsConvert(prevListCoinsConvert => {
            let nameBase = prevListCoinsConvert[idBase].name
            const result = arrayMove(prevListCoinsConvert, oldIndex, newIndex)
            const indexNew = result.map(function (e) { return e.name; }).indexOf(nameBase);
            setIdBase(indexNew)
            return result
        }
        );
    };

    return (
        <div className={classes.root}>
            {/* <HideOnScroll {...props}> */}
            <AppBar position='fixed' className={classes.appBar}>

                <Toolbar>
                    <img src={logoBranco} alt='Logo ConversãoHoje' width='190' className={classes.logoIcon} />

                    <Typography variant="h6" className={classes.title}>

                    </Typography>

                    <CircularProgress
                        className={classes.progress}
                        color="secondary"
                        variant="static"
                        value={completed} />
                </Toolbar>


            </AppBar>
            {/* </HideOnScroll> */}
            <Container maxWidth='md' className={classes.container}>

                <SortableContainer
                    axis='xy'
                    pressDelay={500}
                    onSortEnd={onSortEnd}
                >
                    {
                        listCoinsConvert.map((item, index) =>
                            <SortableItem
                                key={`item-${index}`}
                                index={index}
                                idCard={index}
                                value={item}
                                openDialogSelected={openDialogSelected}
                                quebraGrid={quebraGrid}
                                isBase={idBase === index}
                            />
                        )
                    }
                    <>
                        {
                            offLine ||
                            <Grid item xs={quebraGrid ? 3 : 6}>
                                <ButtonAdd onClick={() => openDialogNew()} />
                            </Grid>
                        }
                    </>
                </SortableContainer>

            </Container>



            <DialogCoin
                open={openDialogConvert}
                setOpen={setOpenDialogConvert}
                coinSelected={coinSelected}
                idCardSelected={idCardSelected}
                idBase={idBase}
                addCoin={addListCoinsConvert}
                removeCoin={removeListCoinsConvert}
                fullScreen={fullScreenDialog}
                className={classes.dialog}
            />

            <Snackbar
                open={offLine}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
            >
                <SnackbarContent
                    className={classes.snackbar}
                    message={<span id="message-id">Ops! Parece que você está sem internet</span>}
                />
            </Snackbar>

        </div>
    );
}